import * as React from "react";
import { app } from "@microsoft/teams-js";
import { AppAnonymousRoute, AppRoute } from "./router/router";
import { Configs, Routes } from "./constants";
import { Provider, teamsDarkTheme, teamsHighContrastTheme, teamsTheme, mergeThemes } from "@fluentui/react-northstar";
import { balcaoV2Theme, balcaoV2DarkTheme } from "./themes/teams-balcaovirtual/theme";
import { getLanguage } from './api/settings-api';
import { getLanguageMeetings } from './api/publicapp-api';
import { updateLocale } from './i18n';
import Resources from "./constants/resources";
import './App.scss';

export interface IAppState {
    theme: any,
    themeStyle: any,
    isTeams: boolean,
}

export default class App extends React.Component<{}, IAppState> {
    theme?: string | null;
    teamsTab: boolean;
    teamsContext: boolean;

    constructor(props: any) {
        super(props);
        let search = window.location.search;
        let params = new URLSearchParams(search);
        this.theme = params.get("theme");
        this.teamsTab = Object.values(Routes.teamsApp).some((route: string) => window.location.href.includes(route));

        const hasAncestorOrigins = 'ancestorOrigins' in window.location;

        if (hasAncestorOrigins) {
            this.teamsContext = window.location.ancestorOrigins[0] &&
                window.location.ancestorOrigins[0].toLowerCase().includes("teams");
        } else {
            this.teamsContext = false;
        }

        this.state = {
            theme: this.theme ? this.theme : Resources.default,
            themeStyle: teamsTheme,
            isTeams: false,
        }
    }

    async componentDidMount() {
        if (this.teamsTab) {
            app.initialize().then(() => {
                this.setState({
                    isTeams: true,
                })
            });

            app.getContext().then((context: app.Context) => {
                this.setState({ theme: context.app.theme! });

                if (!window.location.pathname.includes("errorpage"))
                    this.getLocale(context.app.locale);
            });

            app.registerOnThemeChangeHandler((theme: string) => {
                this.setState({ theme: theme! }, () => {
                    this.forceUpdate();
                });
            });
        }
    }

    public getLocale = async (locale: string) => {
        let responseConfig = await getLanguage();

        if (responseConfig.status === 200 && responseConfig.data) {
            if (responseConfig.data && responseConfig.data !== "")
                updateLocale(responseConfig.data);
            else
                updateLocale(locale);
        } else {
            updateLocale(locale);
        }
    }

    public getLocaleMeetings = async () => {
        let locale = navigator.language;
        let responseConfig = await getLanguageMeetings();

        if (responseConfig.status === 200 && responseConfig.data) {
            if (responseConfig.data)
                updateLocale(responseConfig.data);
            else
                updateLocale(locale);
        } else {
            updateLocale(locale);
        }
    }

    public setThemeComponent = () => {
        if (this.state.theme === Configs.dark) {
            return (
                <Provider theme={mergeThemes(teamsDarkTheme, balcaoV2DarkTheme)}>
                    <div className="darkContainer">
                        {this.getAppDom()}
                    </div>
                </Provider>
            );
        }
        else if (this.state.theme === Configs.contrast) {
            return (
                <Provider theme={teamsHighContrastTheme}>
                    <div className="highContrastContainer">
                        {this.getAppDom()}
                    </div>
                </Provider>
            );
        } else {
            return (
                <Provider theme={mergeThemes(teamsTheme, balcaoV2Theme)} styles={{ background: 'transparent' }}>
                    <div className="default-container">
                        {this.getAppDom()}
                    </div>
                </Provider>
            );
        }
    }

    public getAppDom = () => {
        return (
            <div className="app-container">
                <AppRoute />
            </div>);
    }

    public render() {
        if (!this.state.isTeams) {
            this.getLocaleMeetings();

            return (
                <Provider theme={teamsTheme} styles={{ background: 'transparent' }}>
                    <div className={`${this.teamsContext ? 'meetingsTeams' : 'meetings'}`}>
                        <div className="app-container">
                            <AppAnonymousRoute />
                        </div>
                    </div>
                </Provider>
            )
        } else {
            return (
                <div>
                    {this.setThemeComponent()}
                </div>
            )
        }
    }
}